var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"flex flex-row"},[_c('span',{staticClass:"font-bold"},[_vm._v(" "+_vm._s(_vm.addressDisplay)+" ")]),_c('span',{staticClass:"mx-2"},[_vm._v(" "+_vm._s(_vm.addressString)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }